<template>
  <div class="list">
    <div v-for="(item, index) in goodsData" :key="index" :item="item">
      <div class="itemCont">
        <div class="itemImg">
          <el-image
            lazy
            :src="item.image || avater"
            alt=""
            :preview-src-list="item.image ? [item.image] : []"
            style="width: 140px; height: 140px; padding: 15px 0px"
          />
          <i
            :class="
              index == currentIndex ? 'el-icon-success' : 'el-icon-circle-check'
            "
            @click="goodsChecked(item, index)"
          ></i>
        </div>

        <el-tooltip
          class="item"
          effect="dark"
          :content="item.goodsName"
          placement="top"
        >
          <div class="itemBox name">
            {{ item.goodsName || "" }}
          </div>
        </el-tooltip>
        <div class="itemBox factory">
          {{ item.specification || "" }}
        </div>
        <el-tooltip
          class="item"
          effect="dark"
          :content="item.expireTime"
          placement="top"
        >
          <div class="itemBox factory" v-if="item.expireTime">
            有效期至：{{ item.expireTime }}
          </div>
        </el-tooltip>
        <p class="itemBox factory" v-if="item.salePrice">
          ¥{{ item.salePrice }}
        </p>
      </div>
    </div>
    <el-empty
      v-if="!goodsData.length"
      style="height: 100%; width: 100%"
      description="暂无数据"
    />
  </div>
</template>
<script>
import avater from "/public/img/default.png";
export default {
  props: {
    goodsData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      avater: avater,
      currentIndex: -1,
      form: {},
    };
  },
  methods: {
    goodsChecked(item, index) {
      this.form = { ...item };
      if (this.currentIndex === index) {
        this.currentIndex = -1;
      }else{
        this.currentIndex = index;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.itemCont {
  width: 174px;
  height: 246px;
  border: 1px solid #ccc;
  margin: 0 0 8px 8px;
  border-radius: 4px;

  &:hover {
    border: 2px solid;
    border-color: $borderColorActive;
  }

  .factory {
    color: #595959;
    font-size: 14px;
    height: 22px;
  }

  .itemBox {
    padding: 0px 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 22px;
    margin: 0;
  }

  .name {
    display: block !important;
    font-size: 16px;
    font-weight: 600;
    padding: 4px 10px;
  }

  .itemImg {
    position: relative;
    height: 140px;
    width: 100%;
    display: flex;
    justify-content: center;
    .el-icon-success,
    .el-icon-circle-check {
      position: absolute;
      top: 6px;
      right: 6px;
      font-size: 30px;
    }
    .el-icon-success {
      color: red;
    }

    .el-icon-circle-check {
      color: #f3f3f2;
      &:hover {
        color: red;
      }
    }
  }

  .price {
    font-weight: 700;
    justify-content: end;
  }
}

::v-deep .el-button {
  span {
    margin-left: 0px !important;
  }
}
</style>
